import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {CatalogFormComponent} from "../catalog-form/catalog-form.component";
import {CatalogDataModel} from "../../../../core/services/catalog-data/catalog-data.model";
import {QuestionModalOptions} from "./question-modal-options";
import {CatalogDataService} from "../../../../core/services/catalog-data/catalog-data.service";
import {QuestionModalItemParams} from "./question-modal-item-params";
import {CatalogRequestCreatedEvent} from "../catalog-form/catalog-request-created-event.model";

@Component({
  selector: 'sb-question-modal',
  templateUrl: './question-modal.component.html',
  styleUrls: ['./question-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuestionModalComponent implements OnInit {

  @Input()
  questionItem: string;

  @Input()
  questionItemParams: QuestionModalItemParams;

  @Input()
  modalOptions: QuestionModalOptions;

  @ViewChild('dialog', {static: false})
  dialog: DialogComponent;

  @ViewChild('catalogItem', {static: false})
  catalog: CatalogFormComponent;

  public visible = false;

  public position: any = { X: 'center', Y: 'center' };

  public buttons: ButtonPropsModel[] = null;

  @Input()
  title: string = "";

  @Input()
  closeCallback: any;

  // This is the record id of the target record that is created by the question item in this modal
  @Input()
  recordId: any = null;

  // Unused
  @Input()
  recordTable: any = null;

  // This is a JS object containing the fields of a record
  @Input()
  sourceRec: any = null;

  // This determines if sourceRec described a new record or an existing one
  @Input()
  sourceIsNewRecord: boolean = false;

  @Input()
  submittedEventOnly: boolean = false;

  item: CatalogDataModel = null;

  minHeight = 735;

  height = 735;

  width = 900;

  showCloseIcon = true;

  closeOnEscape = true;

  cssClass = "";

  lastRequestId: string;

  // These three inputs are so we can call methods on the angular component when
  // it is being used as a web component on the Knockout side.
  @Input()
  get ngShowDialog() {
    return this.showDialog();
  }

  @Input()
  get ngHideDialog() {
    return this.hideDialog();
  }

  @Input()
  get ngDestroyDialog() {
    return this.destroyDialog();
  }

  constructor(private catalogDataService: CatalogDataService) { }

  ngOnInit(): void {
  }

  public closeDialog(args: any) {
    this.visible = false;
    this.resetDimensions();
    this.resetItem();

    let closeReason = '';
    if (args.closedBy === 'user action') {
      closeReason = "button";
    } else if (args.closedBy === 'close icon') {
      closeReason = "icon";
    } else if (args.closedBy === 'escape') {
      closeReason = "escape";
    }

    const context = {
      id: this.lastRequestId
    };
    this.closeCallback && this.closeCallback(closeReason, context);
  }

  public async showDialog() {

    this.init();

    if (this?.modalOptions?.showCloseIcon != null) {
      this.showCloseIcon = this.modalOptions?.showCloseIcon;
    }

    if (this?.modalOptions?.closeOnEscape != null) {
      this.closeOnEscape = this.modalOptions?.closeOnEscape;
    }

    if (this?.modalOptions?.title) {
      this.title = this.modalOptions?.title;
    }

    if (this?.modalOptions?.cssClass) {
      this.cssClass = this.modalOptions?.cssClass;
    }

    if (this?.modalOptions?.closeCallback) {
      this.closeCallback = this.modalOptions?.closeCallback;
    }

    this.dialog.show();
    this.visible = true;
  }

  public hideDialog() {
    this.dialog.hide();
    this.visible = false;
    this.resetDimensions();
    this.resetItem();
  }

  public destroyDialog() {
    this.dialog.destroy();
    this.visible = false;
    this.resetDimensions();
    this.resetItem();
  }

  resetDimensions() {
  }

  resetItem() {
    this.item = null;
  }

  onSubmitted (requestId: string) {
    this.lastRequestId = requestId;
    this.closeDialog({closedBy:'user action'});
  }

  onRequestCreated (requestEvent: CatalogRequestCreatedEvent) {
    this.lastRequestId = requestEvent.requestId;
    this.closeDialog({closedBy:'user action'});
  }

  async init() {
    if (this.questionItem) {
      this.item = await this.catalogDataService.getQuestionItemByKey(this.questionItem) || await this.catalogDataService.getQuestionItemById(this.questionItem);
    }
    if (this.questionItemParams) {
      this.recordId = this.questionItemParams.recordId;
      this.recordTable = this.questionItemParams.recordTable;
      this.sourceRec = this.questionItemParams.sourceRec;
      this.sourceIsNewRecord = this.questionItemParams.sourceIsNewRecord;
      this.submittedEventOnly = this.questionItemParams.submittedEventOnly;
    }
  }
}
